var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[(_vm.$appPrefix + "-konsi-solution")]},[_c('MgsP',[_vm._v(_vm._s(_vm.konsi.description))]),_vm._v(" "),_c('MgsP',[_vm._v(_vm._s(_vm.konsi.additional_information))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }